const images = document.querySelectorAll('[data-crossfade-image]');

const crossFadeImages = () => {
    let index = 0;

    if (images.length < 2) {
        return;
    }

    setInterval(() => {
        images.forEach((image) => image.setAttribute('data-crossfade-image', 'hidden'));

        index += 1;
        index >= images.length && (index = 0);

        images[index].setAttribute('data-crossfade-image', 'visible');
    }, 2000);
};

images.length && crossFadeImages();
